var module = angular.module('octopusApp.projects');

module.controller('ScriptConsoleController', function ($scope, $q, busy, octopusRepository, $location, unsavedChanges) {
    var vm = this;
    var isLoading = vm.isLoading = busy.create();
    var isSaving = vm.isSaving = busy.create();
    var retry = $location.search().retry;

    vm.selectionModes = ['Machines', 'Environments'];
    vm.run = run;
    vm.environmentIds = [];
    vm.targetRoles = [];
    vm.machineIds = [];

    vm.scriptBody = '';
    vm.syntax = 'PowerShell';
    vm.selectionMode = vm.selectionModes[0];

    vm.availableRoles = [];
    vm.environments = [];
    vm.machines = [];


    function init() {
        var loadResources = $q.all([octopusRepository.Environments.all(), octopusRepository.Machines.all(), octopusRepository.MachineRoles.all()]).then(function (data) {
            vm.availableRoles = data[2];
            vm.environments = data[0];
            vm.machines = data[1];
        });


        isLoading.promise(loadResources);

        if (retry) {
            var loadExistingValues = octopusRepository.Tasks.get(retry)
                .then(function (retried) {
                    vm.scriptBody = retried.Arguments.ScriptBody;
                    vm.syntax = retried.Arguments.Syntax || 'PowerShell';
                    if (retried.Arguments.MachineIds && retried.Arguments.MachineIds.length > 0) {
                        vm.machineIds = retried.Arguments.MachineIds;
                        vm.selectionMode = 'Machines';
                    } else {
                        vm.environmentIds = retried.Arguments.EnvironmentIds;
                        vm.targetRoles = retried.Arguments.TargetRoles;
                        vm.selectionMode = 'Environments';
                    }
                });
            isLoading.promise(loadExistingValues);
        }
    }

    function run() {
        if (vm.scriptBody.trim().length === 0) {
            isSaving.showError('A script body must be provided.');
            return;
        }

        var task = {
            Name: 'AdHocScript',
            Description: 'Script run from management console',
            Arguments: {
                ScriptBody: vm.scriptBody,
                Syntax: vm.syntax
            }
        };

        if (vm.selectionMode === 'Machines') {
            if (vm.machineIds.length === 0) {
                isSaving.showError('At least one deployment target must be selected.');
                return;
            }
            task.Arguments.MachineIds = vm.machineIds;
        } else {
            task.Arguments.EnvironmentIds = vm.environmentIds;
            task.Arguments.TargetRoles = vm.targetRoles;
        }

        isSaving.promise(octopusRepository.Tasks.create(task).then(function (created) {
            unsavedChanges.saved();
            $location.path('/tasks/' + created.Id);
        }));
    }

    init();
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/management/controllers/script_console_controller.js
// module id = 475
// module chunks = 1